unable to read source [project]/packages/src/components/base/spinner/Spinner.tsx